/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface DeclineLadderChallengeResponse
 */
export interface DeclineLadderChallengeResponse {
    /**
     * 
     * @type {LadderChallenge}
     * @memberof DeclineLadderChallengeResponse
     */
    challenge: LadderChallenge;
}

/**
 * Check if a given object implements the DeclineLadderChallengeResponse interface.
 */
export function instanceOfDeclineLadderChallengeResponse(value: object): value is DeclineLadderChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function DeclineLadderChallengeResponseFromJSON(json: any): DeclineLadderChallengeResponse {
    return DeclineLadderChallengeResponseFromJSONTyped(json, false);
}

export function DeclineLadderChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineLadderChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': LadderChallengeFromJSON(json['challenge']),
    };
}

export function DeclineLadderChallengeResponseToJSON(json: any): DeclineLadderChallengeResponse {
    return DeclineLadderChallengeResponseToJSONTyped(json, false);
}

export function DeclineLadderChallengeResponseToJSONTyped(value?: DeclineLadderChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': LadderChallengeToJSON(value['challenge']),
    };
}

